module.exports = __webpack_public_path__ + "static/img/Broncos.afcbd83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Broncos.svg
// module id = FBPW
// module chunks = 1